module.exports = __webpack_public_path__ + "media/question11_au.8d7cdea7.mp3";